import { render, staticRenderFns } from "./apStat.vue?vue&type=template&id=a620d122&scoped=true&"
import script from "./apStat.vue?vue&type=script&lang=js&"
export * from "./apStat.vue?vue&type=script&lang=js&"
import style0 from "./apStat.vue?vue&type=style&index=0&id=a620d122&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a620d122",
  null
  
)

component.options.__file = "apStat.vue"
export default component.exports